import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IconButton, Card, Collapse,Tooltip } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import DataField from "./DataField_notOK/DataField";
import { titleCase, formatAsMoney } from "../../utils/utils"
import { useTranslation } from "react-i18next";
import {credit_translations, getProperMetadata} from "../../utils/utils"

function CreditAnalysisNaturalPersonCard(props) {

    let { credit_analysis, user_data } = props 

    const { t } = useTranslation();

    const { analysis_status, not_listed } = credit_translations

    const [expanded, setExpanded] = useState(false);

    const handleExpand = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };

    let decision_metadata = credit_analysis.credit_proposal_natural_person_analysis_events ? getProperMetadata(credit_analysis.credit_proposal_natural_person_analysis_events) : "" 
    let basic_data = decision_metadata ? (decision_metadata || {}).basic_data : ""

    let showLinkToAnalysis = !(credit_analysis.analysis_status === "pending" || credit_analysis.analysis_status === "waiting_for_data" || credit_analysis.analysis_status === "failed" ) 

    return (
        <Card className={["listCard","collapse"].join(" ")}>
            <div style={{display:"flex", justifyContent: "space-between"}}>
                {user_data.business_group_key ? credit_analysis.company_name ?
                <div 
                    className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                    style={{flex:"1 1 120px", textAlign:"center"}}
                >
                    {credit_analysis.company_name}
                </div> : null:null}
                {showLinkToAnalysis
                    ? <Link 
                        className={["listCardItem", "link", "subtitleSize", "bold"].join(" ")}
                        style={{flex:"1 1 120px", textAlign:"center"}}
                        to={"/credit-analysis-natural-person/" + credit_analysis.credit_proposal_natural_person_key}
                    >
                       {credit_analysis.is_manual_analysis ? t("Requisição Manual") : `${t("Cliente")} #${credit_analysis.id}`}
                    </Link>
                    : <div 
                    className={["listCardItem", "subtitleSize", "bold"].join(" ")}
                    style={{flex:"1 1 120px", textAlign:"center"}}
                    >
                       {credit_analysis.is_manual_analysis ? t("Requisição Manual") : `${t("Cliente")} #${credit_analysis.id}`}
                    </div>}
                <div 
                    className={["listCardItem", "normalText", "subtitleSize"].join(" ")} 
                    style={{flex:"1 1 120px", textAlign:"center"}}
                >
                    {(!!credit_analysis.name || !!(basic_data || {}).name) 
                        ? titleCase(credit_analysis.name, "-")
                        :  titleCase((basic_data || {}).name, "-")}
                </div>
                <div 
                    className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")}
                    style={{flex:"1 1 145px", textAlign:"center"}}
                >
                    {credit_analysis.document_number}
                </div>
                <div 
                    className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")}
                    style={{flex:"1 1 145px", textAlign:"center"}}
                >
                    {credit_analysis.financial 
                        ? formatAsMoney(credit_analysis.financial.currency, credit_analysis.financial.amount)
                        : "-"}
                </div>
                <div 
                    className={["listCardItem", "normalText", "normalMediumSize", "bold"].join(" ")} 
                    style={{flex:"1 1 45px", textAlign:"center", cursor: "default"}}  
                >

                        <Tooltip title={<p className="tooltipText">{analysis_status[credit_analysis.analysis_status] ? t(analysis_status[credit_analysis.analysis_status].description) : t(credit_analysis.analysis_status)}</p>}>
                        <div className={["circle", "small"].join(" ")} style={{backgroundColor: (analysis_status[credit_analysis.analysis_status] || not_listed).color }}>
                            {t((analysis_status[credit_analysis.analysis_status] || not_listed).siglum)}
                        </div>
                    </Tooltip>
                </div>
                <div 
                    className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                    style={{flex:"1 1 70px", textAlign:"center"}}
                >
                    {t("date_time_format", {date_time: credit_analysis.created_at})}
                </div>
                <div
                    className="listCardItem"
                    style={{flex:"0 1 70px", textAlign:"center"}}
                >
                    <IconButton onClick={handleExpand}>
                        {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </IconButton>
                </div>
            </div>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
            <div className={["internalCollapse", "twoColumn"].join(" ")}>
                <DataField
                name={t("monthly_income")}
                data={credit_analysis.monthly_income ? formatAsMoney("BRL", credit_analysis.monthly_income) : " - "}
                />
                <DataField
                    name={t("declared_assets")}
                    data={credit_analysis.declared_assets ? formatAsMoney("BRL", credit_analysis.declared_assets) : " - "}
                />
                {!!credit_analysis.installments_enrichment && 
                    <DataField
                            title={t("first_installment")}
                            label={formatAsMoney("BRL", credit_analysis.installments_enrichment[0].total_amount)}
                            size={"normalMediumSize"}
                            titleNoWrap={false}
                            margin="5px"
                        />}
            </div>
            <ObservationComponent analysis_status_events={credit_analysis.analysis_status_events} />
        </Collapse>
        </Card>
    );
}

export default CreditAnalysisNaturalPersonCard;

function ObservationComponent(props) {
    
    const { t } = useTranslation();

  if (props.analysis_status_events === undefined){
    return null
  }
  else if (props.analysis_status_events[props.analysis_status_events.length - 1].observation === null){
    return null
  }
  else {
    return (
      <div style={{margin:"20px"}}>
        <DataField
          name={t("Observações")}
          data={props.analysis_status_events[props.analysis_status_events.length - 1].observation}
        />
      </div>
    )
  }
}